import RemoteApi from './BaseRemoteApi'
import { APIStatus } from './models';

export default class XAPIProxy extends RemoteApi {

    constructor(authorization: string) {
        super('/proxies/xapi/v1', authorization)
    }

    fetchStatus(orgId: string, envId: string, apiId: string | number, appId: number): Promise<APIStatus> {
      return this._get(
          [
              'organizations',
              orgId,
              'environments',
              envId,
              'apis',
              apiId.toString(),
              'deployments',
              appId.toString(),
              'status'
          ],
          true
      );
    }
}
